import React from "react";
import { Comment } from "../../../Models/Comment";
import { commentPingSplitService } from "../../../Services/CommentPingSplitService";
import { commentLinkSplitService } from "../../../Services/CommentLinkSplitService";
import CommentPingDisplay from "./CommentPingDisplay";

const uuid = require("uuid");

type Props = {
  comment: Comment;
};

export default class CommentTextWithPings extends React.Component<Props> {
  render() {
    const commentText = this.props.comment.comment;

    // if we have at least one ping we must render differently
    if (!!this.props.comment.pings && this.props.comment.pings.length > 0) {
      // we have to iterate through the pings to display this

      return (
        <span>
          {this.props.comment.pings.map((el, index) => {
            // if this is the first ping, include the stuff before it
            const beforeString =
              index === 0
                ? commentPingSplitService.getTextBetweenPingAndStart(commentText, el.number)
                : "";
            // get the stuff after it too
            const afterString = commentPingSplitService.getTextBetweenPingAndNextPing(
              commentText,
              el.number
            );

            return (
              <span key={uuid()}>
                {commentLinkSplitService.getLinkDisplay(beforeString)}
                <CommentPingDisplay ping={el} />
                {commentLinkSplitService.getLinkDisplay(afterString)}
              </span>
            );
          })}
        </span>
      );
    }

    // if the comment is deleted put in deleted text
    if (this.props.comment.isDeleted) {
      this.props.comment.comment = "Deleted";
    }

    // just render the comment
    return <span>{commentLinkSplitService.getLinkDisplay(this.props.comment.comment)}</span>;
  }
}
